import axios from "axios";

export const searchCID = async (param) => {
  try {
    const result = await axios.request(
      "https://sps1-api.vietmap.vn/api/License/searchbycid",

      {
        method: "post",
        maxBodyLength: Infinity,
        headers: {
          "accept": "text/plain",
          "Content-Type": "application/json",
        },

        data: param,
      }
    );
    console.log("result", result);
    return result;
  } catch (error) {

    console.log("API Error", error);
  }
};
